import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Modal from '@mui/material/Modal';
import { keyframes } from '@emotion/react';
import { IoFitnessOutline } from 'react-icons/io5';

// Define fade-in animation
const fadeIn = keyframes`
  0% { opacity: 0; transform: scale(0.95); }
  100% { opacity: 1; transform: scale(1); }
`;

// function InstructionsModal({ showInstructions, setShowInstructions }) {
function InstructionsModal({ showInstructions, setShowInstructions, onAccept }) {
  return (

    
    <Modal
      open={showInstructions}
      onClose={() => setShowInstructions(false)}
      aria-labelledby="instructions-title"
      aria-describedby="instructions-content"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backdropFilter: 'blur(3px)' // Add backdrop blur for modern look
      }}
    >
      <Box
        sx={{
          p: { xs: 2, sm: 3, md: 4 },
          bgcolor: 'white',
          borderRadius: 2,
          width: { xs: '90%', sm: 450 }, // Responsive width
          maxWidth: '90vw', // Prevent overflow on small screens
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
          animation: `${fadeIn} 0.3s ease-out`, // Apply fade-in animation
          position: 'relative',
          transform: 'translate(-50%, -50%)',
          top: '50%',
          left: '50%'
        }}
        role="dialog"
      >
        <Typography
          id="instructions-title"
          variant="h6"
          sx={{
            fontWeight: 600,
            color: '#1a73e8',
            mb: 2,
            fontSize: { xs: '1.5rem', sm: '1.75rem', md: '1.3rem' }
          }}
        >
          Capture Your Yoga Pose
        </Typography>
        <List sx={{ p: 0, mb: 2 }}>
          {[
            'Position yourself 3–4 feet from the camera.',
            'Ensure your full body is visible in the frame.',
            'Hold still for 3 seconds when the green border appears.',
            'Maintain the pose for 15 seconds during the countdown.',
            'Avoid moving to ensure an accurate capture.'
          ].map((text, index) => (
            <ListItem key={index} sx={{ py: 0.5, alignItems: 'flex-start' }}>
              <ListItemIcon sx={{ minWidth: 40, color: '#4caf50', mt: { xs: 0.5, sm: 0.75 } }}>
                <IoFitnessOutline size={24} />
              </ListItemIcon>
              <ListItemText
                primary={text}
                primaryTypographyProps={{
                  variant: 'body1',
                  sx: { fontSize: { xs: '0.9rem', sm: '1rem' }, color: '#333' }
                }}
              />
            </ListItem>
          ))}
        </List>
        <Button
          variant="contained"
          onClick={onAccept}
          // onClick={() => setShowInstructions(false)}
          sx={{
            mt: 2,
            bgcolor: '#1a73e8',
            '&:hover': { bgcolor: '#1557b0' },
            fontSize: { xs: '0.9rem', sm: '1rem' },
            borderRadius: 1,
            width: '100%',
            py: 1.2,
            textTransform: 'none'
          }}
          aria-label="Close instructions"
        >
          Got It!
        </Button>
      </Box>
    </Modal>
  );
}

export default InstructionsModal;
